<template>
  <div>
    <div id="loading-bg">
        <div id="loading-bar"></div>
    </div>

    <nav class="navbar navbar-expand-md navbar-dark bg-sky">
      <div class="container">
        <router-link to="/" class="navbar-brand">
          Merkle Town<br />
          <span class="sub-brand">Explore the certificate transparency ecosystem.</span>
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarLinks" aria-controls="navbarLinks" aria-expanded="false" aria-label="Toggle navigation">
          <octicon name="three-bars"></octicon>
        </button>

        <div class="collapse navbar-collapse" id="navbarLinks">
          <ul class="navbar-nav ml-auto">
            <li :class="{'nav-item': true, 'active': onLogList}"><router-link class="nav-link" to="/logs">Log List</router-link></li>
            <li :class="{'nav-item': true, 'active': onAbout}"><router-link class="nav-link" to="/about">About</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'Navbar',
    computed: {
      onLogList: function() { return this.$route.path == '/logs' },
      onAbout: function() { return this.$route.path == '/about' },
    },
  }
</script>

<style>
  div#loading-bg {
    position: fixed;
    height: 5px;
    width: 100%;
    z-index: 1;
  }
  div#loading-bg div#loading-bar {
    background-color: white;
    height: 5px;
    width: 0%;

    position: fixed;
    top: 0;
    left: 0;
  }
  div#loading-bg div.active {
    animation: loading 3s linear 0.1s infinite;
  }
  @keyframes loading {
    from { left: 0%; width: 0%; }
    50% { left: 0%; width: 100%; }
    to { left: 100%; width: 0%; }
  }

  .navbar {
    margin-bottom: 1rem;
  }
  .navbar-brand {
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 1.5rem;

    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .navbar-brand .sub-brand {
    font-size: 0.9rem;
    font-weight: lighter;
    color: #e0e1ee;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .bg-sky {
    background: linear-gradient(to left,#77c4e3,#8176b5);
  }

  ul.navbar-nav li.active a.nav-link {
    color: white!important;
    border-bottom: 2px solid white;
  }

  a.nav-link {
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.75)!important;
    font-weight: bold;
    letter-spacing: 1px;
  }
  a.nav-link:hover {
    color: white!important;
  }
  .navbar-search input {
    font-size: 0.85rem;
  }

  .navbar-toggler {
      border: none;
  }
  .navbar-toggler svg {
      width: 2rem;
      height: 2rem;
      color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Navbar.vue